import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/";
import Energy from "@/views/Energy";
import Consumption from "@/views/Consumption";
import Calculation from "@/views/Calculation";
import Contact from "@/views/Contact";
import Simulation from "@/views/Simulation";
import Comparison from "@/views/Comparison";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.URL_BASE,
  routes: [
    {
      path: "/energy",
      name: "Energy",
      component: Energy
    },
    {
      path: "/consumption",
      name: "Consumption",
      component: Consumption,
      beforeEnter(to, from, next) {
        if (store.state.energy.valid) {
          next();
        } else {
          next("/energy");
        }
      }
    },
    {
      path: "/calculation",
      name: "Calculation",
      component: Calculation,
      beforeEnter(to, from, next) {
        if (store.state.energy.valid && store.state.consumption.valid) {
          next();
        } else {
          next("/consumption");
        }
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      beforeEnter(to, from, next) {
        if (
          store.state.energy.valid &&
          store.state.consumption.valid &&
          store.state.calculation.valid
        ) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/simulation",
      name: "Simulation",
      component: Simulation,
      beforeEnter(to, from, next) {
        if (store.state.calculation.valid) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/comparison",
      name: "Comparison",
      component: Comparison,
      beforeEnter(to, from, next) {
        if (store.state.calculation.valid) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/",
      redirect: to => {
        let path = "/energy";
        if (
          store.state.energy.valid &&
          store.state.consumption.valid &&
          store.state.calculation.valid
        )
          path = "/contact";
        else if (store.state.energy.valid && store.state.consumption.valid)
          path = "/calculation";
        else if (store.state.energy.valid) path = "/consumption";
        else path = "/energy";

        return path;
      }
    }
  ]
});

router.beforeEach(async(to, from, next) => {
  if (to.query.lang) {
    store.dispatch("middleware/setLanguage", to.query.lang);
  }

  if (to.query.newSession !== undefined) {
    store.dispatch("middleware/newSession");
    delete to.query.newSession;
    next({name: "Energy", query: to.query});
  } else if (to.query.uuid) {
    await store.dispatch("middleware/setByUuid", to.query.uuid);
    delete to.query.uuid;  
    next({name: "Contact", query: to.query});
  }

  if (!to.name) {
    next("/energy");
  } else next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js